/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import LogicContext from "../../Context/LogicContext";
import { GetBankingList, SetBankingList } from "../../store/bankingAtom";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { stockService } from "../../services/stockService";
import { bankingService } from "../../services/bankingService";
import { BankingStatItem } from "./BankingStatItem";
import { HandCoins, Landmark } from 'lucide-react';
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

const BankingMainPage = () => {
  const { pathname } = useLocation();
  const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext); // Select only needed context value
 

  const getBankingData  = GetBankingList();
  const setBankingData  = SetBankingList();
  const myPromiseModal = createModal(GeneralModal);
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const mountRef = useRef(false);
  const [searchText, setSearchText] = useState("");
  

  // Memoized columns to prevent recreation
  const columns = useMemo(
    () => [
      {
        title: "Account Id",
        key: "account_id",
        dataIndex: "account_id",
        className: "text-primary",
        sorter: (a, b) => (a?.account_id ?? "") - (b?.account_id ?? ""),
      },
      {
        title: "Account Name",
        dataIndex: "account_name",
        sorter: (a, b) => (a?.account_name ?? "").localeCompare(b?.account_name ?? ""),
      },
      {
        title: "Account No",
        dataIndex: "account_number",
        sorter: (a, b) => (a?.account_number ?? "").localeCompare(b?.account_number ?? ""),
      },
      {
        title: "Amount",
        dataIndex: "amount",
        sorter: (a, b) => (a?.amount ?? "") - (b?.amount ?? ""),
          render: (record) => <span className="font-bold " >{formatCustomNumber(record)}</span>,
      },
      {
        title: "Currency ",
        dataIndex: "currency_name_short",
        sorter: (a, b) => (a?.currency_name_short ?? "").localeCompare(b?.currency_name_short ?? ""),
      },

 
  
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
   
    mountRef.current = true;
    if (getBankingData?.bank_info?.length > 0) {
      setTableData(getBankingData?.bank_info);
    }else{
        getBankingListFromAPI();
    }
    return () => {
      mountRef.current = false;
    };
  }, [getBankingData]);


  // Handle session-based reload
  useEffect(() => {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getBankingListFromAPI();
    }
  }, []);


  // Fetch sales order list with abortable request
  const getBankingListFromAPI = useCallback(async () => {
   
    try {
      const response = await bankingService.bankingList();
        setBankingData(response.data);
      
    } catch (err) {
        console.error(err);
    }
   
  }, [getBankingData]);




  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);

  const addNewBanking = useCallback(() => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }, [currModuleId, currModuleName, currUserMenu, navigate]);


  const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await stockService.stockAdjustmentListByDate(formData);
      if (response?.data?.length) {
        setTableData(response.data);
      } else {
        showToast("No result found", "");
        setTableData([]);
      }
    } catch (err) {
      showToast("Error", "error");
    }
  }, [getValues, showToast]);




  const handleRowClick = useCallback(
    (data) => {
      const id = data["account_id"];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );



  const onClearInput = ()=> {
    setSearchText("");
    setTableData(getBankingData.bank_info || []);

   }



  const handleSearch = (text) => {
    setSearchText(text);
   
     if (text.trim() === "") {
      setTableData(getBankingData?.bank_info || []);
       return;
     }
   
     const searchTerm = text.toLowerCase();
     const filtered = (getBankingData?.bank_info || []).filter(credit =>
       Object.values(credit).some(value => 
         value?.toString().toLowerCase().includes(searchTerm)
       )
     );
     setTableData(filtered); 
   };

  return (
    <>
  
      <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">
        <div className="flex items-center space-x-2">

        <div className="flex w-full flex-col gap-8 p-6 sm:flex-row sm:items-center">
      
      {/* Item 1: Cash In Hand */}
      <BankingStatItem 
        icon={HandCoins}
        // Using a very light gray/slate for the background to match the screenshot
        iconBg="bg-gray-100" 
        iconColor="text-gray-500"
        label="Cash In Hand"
        // value="NGN358,408,070.00"
        value={getBankingData?.cash_bank_balance_info?.[0]?.cash_amount || 0}
      />

      {/* Item 2: Bank Balance */}
      <BankingStatItem 
        icon={Landmark}
        // Using light emerald/green for the background
        iconBg="bg-green-50" 
        iconColor="text-green-600"
        label="Bank Balance"
        // value="NGN16,467.00"
        value={getBankingData?.cash_bank_balance_info?.[0]?.bank_amount || 0}

      />
      
    </div>

          {/* {itemSelected.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Bulk Actions</Dropdown.Toggle>
              <Dropdown.Menu>
                {salesOrderData["Bulk_Action"]?.map((action, i) => (
                  <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                    {action.Action_Name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <SalesOrderFilter list={salesOrderData["Filtering_Criteria"]} onFilterSelect={onFilterSelect} />
          )} */}
          <Tooltip title="Reload">
            <div
              onClick={getBankingListFromAPI}
              className="h-fit w-fit p-2 rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-300"
            >
              <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />
            </div>
          </Tooltip>
        </div>

        {/* <div className="flex flex-row items-end space-x-2">
          <div>
            <span className="ml-1 text-sm">From Date:</span>
            <input
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              {...register("from_date")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <span className="ml-1 text-sm">To Date:</span>
            <input
              {...register("to_date")}
              defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
              type="date"
            />
          </div>
          <div>
            <button
              onClick={searchByDate}
              type="button"
              className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
            >
              Search
            </button>
          </div>
        </div> */}

        <div className="flex items-center space-x-4">
          <Tooltip title="Add New">
            <buttonS
              onClick={addNewBanking}
              className="ml-2 h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1.5px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
            >
              <FaPlus className="h-[16px] w-[16px] text-gray-600" />
            </buttonS>
          </Tooltip>
        </div>

      </div>

                  {/* Start of search */}
    <div className="flex justify-center mt-4">
    <div className="flex flex-col w-full md:w-1/3">
      <input
        type="text"
        placeholder="Search in table"
        value={searchText}
        onKeyDown={(e) => {
          if (e.key === 'Backspace') {
            onClearInput();
          }
        }}
        onChange={(e) => handleSearch(e.target.value)}
        className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
      />
    </div>
  </div>
  {/* End of search */}

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.account_id}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
};

export default React.memo(BankingMainPage); // Memoize component